import { AnimatedBackground } from './AnimatedBackground';
import { MilesLogo } from './MilesLogo';

interface AuthLayoutProps {
  children: React.ReactNode;
  maxWidth?: 'sm' | 'md';
}

export function AuthLayout({ children, maxWidth = 'sm' }: AuthLayoutProps) {
  const widthClass = maxWidth === 'md' ? 'max-w-md' : 'max-w-sm';

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative">
      <AnimatedBackground />
      <div
        className={`relative z-10 w-full ${widthClass} animate-[fadeIn_0.4s_ease-out]`}
      >
        <div className="text-center mb-10 flex justify-center">
          <MilesLogo size="lg" linked={false} />
        </div>
        {children}
      </div>
    </div>
  );
}
